import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationDimensionPluginService } from './dimension.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-dimension-edit',
    templateUrl: './dimension-edit.component.html',
    standalone: false
})
export class InstallationDimensionEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  measuringUnits: any[];

  private sub = new Subscription();

  @ViewChild('measuringUnitsModal', { static: true }) measuringUnitsModal: ModalComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationDimensionPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateDimensions(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.controls['dimensions'].markAsTouched();
  }

  public openUnitsSelector() {
    this.openSelector(this.measuringUnitsModal, this.measuringUnits, this.editForm.controls.units.value);
  }

  public selectDimensionsMenu(item: any) {
    const selectedIndex = this.editForm.controls.units.value === item.selectedIndex ? '' : item.selectedIndex;
    this.editForm.controls.units.setValue(selectedIndex);
  }

  public maxLengthCheck(control: any, event: InputEvent) {
    const rg = /^((\d+)?([\.\,]\d{0,2})?)$/;
    const matchRg = /((\d+)?([\.\,]\d{0,2})?)/;
    if (event.data === '.') return;

    if (!rg.test(control.value)) {
      const matchArray = `${control.value}`.match(matchRg);
      const matchValue = matchArray ? matchArray[0] : '';
      control.setValue(matchValue);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.measuringUnits = this.pluginService.getMeasuringUnits();
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      label: new UntypedFormControl(this.plugin.config.Dimensions.Label ?? ''),
      length: new UntypedFormControl(this.plugin.config.Dimensions.Length ?? '', Validators.min(0)),
      width: new UntypedFormControl(this.plugin.config.Dimensions.Width ?? '', Validators.min(0)),
      height: new UntypedFormControl(this.plugin.config.Dimensions.Height ?? '', Validators.min(0)),
      units: new UntypedFormControl(this.plugin.config.Dimensions.Units ?? '')
    });
  }
}
